class VideoOverlayElement extends HTMLElement {
    static get observedAttributes() { 
      return ['src']; 
    }
  
    constructor() {
        super();
        this.render();
    }
  
  	get player() {
  		return this.querySelector('#videoModalPlayer');
  	}
  
  	get playerObj() {
      if(!this._playerObj){
        this._playerObj = new YT.Player('videoModalPlayer');
        
      } 
      return this._playerObj;
  	}
  
    get modal() {
        return this.querySelector('#videoModal');
    }
  
    get closeBtn () {
      return this.querySelector('.modal__close');
    }
  
  	show() {
    	this.modal.setAttribute('aria-hidden', 'false');
	      this.updateVideoSource();
    }
  
    hide() {
    	this.modal.setAttribute('aria-hidden', 'true');
		this.player.src = '';
    }
  
	updateVideoSource() {
      this.player.src = `${this.getAttribute('src')}?enablejsapi=1`;
    }
  
    connectedCallback() {
        
      if (typeof(YT) == 'undefined' || typeof(YT.Player) == 'undefined') {
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      }
      this.closeBtn.addEventListener('click', this.hide.bind(this));
    }

    disconnectedCallback() {
        this.closeBtn.addEventListener('click', this.hide.bind(this));
    }

    attributeChangedCallback(name, oldValue, newValue) {
      console.log(name, oldValue, newValue);
      switch(name) {
        case 'src':
          this.updateVideoSource(newValue);
          break;
      }
    }

    render() {
        this.innerHTML = `
		<div id="videoModal" class="modal" aria-hidden="true" tabindex="-1">
          <div class="modal__dialog modal__dialog--stretch" role="dialog">
              <button class="modal__close link" data-action="close-modal">
                <svg class="icon icon--close" viewBox="0 0 19 19" role="presentation">
                    <path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fill-rule="evenodd"></path>
                </svg>
              </button>
              <div class="modal__loader">
                <svg class="icon icon--search-loader" viewBox="0 0 64 64" role="presentation">
                  <path opacity=".4" d="M23.8589104 1.05290547C40.92335108-3.43614731 58.45816642 6.79494359 62.94709453 23.8589104c4.48905278 17.06444068-5.74156424 34.59913135-22.80600493 39.08818413S5.54195825 57.2055303 1.05290547 40.1410896C-3.43602265 23.0771228 6.7944697 5.54195825 23.8589104 1.05290547zM38.6146353 57.1445143c13.8647142-3.64731754 22.17719655-17.89443541 18.529879-31.75914961-3.64743965-13.86517841-17.8944354-22.17719655-31.7591496-18.529879S3.20804604 24.7494569 6.8554857 38.6146353c3.64731753 13.8647142 17.8944354 22.17719655 31.7591496 18.529879z"></path>
                  <path d="M1.05290547 40.1410896l5.80258022-1.5264543c3.64731754 13.8647142 17.89443541 22.17719655 31.75914961 18.529879l1.5264543 5.80258023C23.07664892 67.43614731 5.54195825 57.2055303 1.05290547 40.1410896z"></path>
                </svg>
              </div>
              <div class="modal__inner">
                <div class="card">
                  <div class="card__section" style="
                    position: relative;
                    padding-bottom: calc(315 / 560 * 100%);
                  ">
<iframe id="videoModalPlayer" ${this.hasAttribute('src') ? `src="${this.getAttribute('src')}"` : ''}" width="560" height="315" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" style="
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        width: 100%;
                        height: 100%;
                        padding: 50px;
                      "></iframe>
                  </div>
                </div>
              </div>
          </div>
      </div>`;
    }
}

window.customElements.define('video-overlay', VideoOverlayElement)